module.exports = __webpack_public_path__ + "img/ASC_SORT.20f78585.svg";